import { render, staticRenderFns } from "./complainDialog.vue?vue&type=template&id=b67dd8f8&scoped=true"
import script from "./complainDialog.vue?vue&type=script&lang=js"
export * from "./complainDialog.vue?vue&type=script&lang=js"
import style0 from "./complainDialog.vue?vue&type=style&index=0&id=b67dd8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67dd8f8",
  null
  
)

export default component.exports